<h1 *ngIf="isAddMode">Add User</h1>
<h1 *ngIf="!isAddMode">Edit User</h1>
<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="firstName" class="form-label">First Name</label>
            <input type="text" formControlName="firstName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.firstName.errors }" aria-describedby="firstNameError" />
            <div *ngIf="submitted && f.firstName.errors" class="invalid-feedback" id="firstNameError">
                <div *ngIf="f.firstName.errors.required">First Name is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="lastName" class="form-label">Last Name</label>
            <input type="text" formControlName="lastName" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.lastName.errors }" aria-describedby="lastNameError" />
            <div *ngIf="submitted && f.lastName.errors" class="invalid-feedback" id="lastNameError">
                <div *ngIf="f.lastName.errors.required">Last Name is required</div>
            </div>
        </div>
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="username" class="form-label">Username</label>
            <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" aria-describedby="usernameError" />
            <div *ngIf="submitted && f.username.errors" class="invalid-feedback" id="usernameError">
                <div *ngIf="f.username.errors.required">Username is required</div>
            </div>
        </div>
        <div class="mb-3 col">
            <label for="password" class="form-label">
                Password
                <em *ngIf="!isAddMode">(Leave blank to keep the same password)</em>
            </label>
            <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" aria-describedby="passwordError" />
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback" id="passwordError">
                <div *ngIf="f.password.errors.required">Password is required</div>
                <div *ngIf="f.password.errors.minlength">Password must be at least 6 characters</div>
            </div>
        </div>
    </div>
    <div class="row g-3">
        <div class="mb-3 col">
            <label for="role" class="form-label">Role</label>
            <select class="form-select" formControlName="role" [ngClass]="{ 'is-invalid': submitted && f.role.errors }" aria-describedby="roleError">
                <option *ngFor="let role of roles" [ngValue]="role">
                  {{ role }}
                </option>
              </select>
              <div *ngIf="submitted && f.role.errors" class="invalid-feedback" id="roleError">
                <div *ngIf="f.role.errors.required">Role needs to be selected</div>
            </div>
        </div>
        <div class="mb-3 col" *ngIf="user.role =='admin'">
            <label for="specialRoleAccess" class="form-label">Special Role</label>
            <div class="border rounded p-2" style="max-height: 180px; overflow-y: auto;">
                <div class="form-check" *ngFor="let specialRole of specialRoles; let i = index">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        [id]="'specialRoleAccess-' + i"
                        [checked]="isSpecialRoleSelected(specialRole)"
                        (change)="toggleSpecialRole(specialRole, $any($event.target).checked)"
                    />
                    <label class="form-check-label" [for]="'specialRoleAccess-' + i">{{ specialRole }}</label>
                </div>
            </div>
        </div>
        <div class="mb-3 col" *ngIf="user.role =='admin'">
            <label for="employeeDealerList" class="form-label">Employee Dealer List</label>
            <select multiple="multiple" class="form-control" formControlName="employeeDealerList" [ngClass]="{ 'is-invalid': submitted && f.employeeDealerList.errors }" >
                <option *ngFor="let dealer of dealerList" [ngValue]="dealer.dealerId">
                  {{ dealer.dealerGroupName ? dealer.dealerGroupName + "-" + dealer.dealerName : dealer.dealerName }}
                </option>
              </select>
        </div>

        <div class="mb-3 col">
            <label for="dealerId" class="form-label">Dealer Id</label>
            <input type="text" formControlName="dealerId" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.dealerId.errors }" aria-describedby="dealerIdError" />
            <div *ngIf="submitted && f.dealerId.errors" class="invalid-feedback" id="dealerIdError">
                <div *ngIf="f.dealerId.errors.required">Dealer Id is required</div>
            </div>
        </div>
    </div>
    <div class="mb-3">
        <button [disabled]="loading" class="btn btn-primary">
            <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
            Save
        </button>
        <a routerLink="../../" class="btn btn-link" *ngIf="!isAddMode">Cancel</a>
        <a routerLink="../" class="btn btn-link" *ngIf="isAddMode">Cancel</a>
    </div>
</form>
